import { useTranslation } from "react-i18next";

import { NoteTypeIcon } from "components";
import { APPOINTMENT_NOTE_TYPES } from "models";
import "modules/AppointmentDetails/components/AppointmentNoteModal/components/AppointmentNoteModalHeader/AppointmentNoteModalHeader.scss";

type AddUpdateNoteHeaderProps = {
  type: APPOINTMENT_NOTE_TYPES;
  isEdit: boolean;
};

export const AppointmentNoteModalHeader = ({ type, isEdit }: AddUpdateNoteHeaderProps) => {
  const { t } = useTranslation();

  const noteLabels: Partial<Record<APPOINTMENT_NOTE_TYPES, string>> = {
    [APPOINTMENT_NOTE_TYPES.WO]: isEdit ? t("v8_edit_note", "Edit Note") : t("v8_add_note", "Add Note"),
    [APPOINTMENT_NOTE_TYPES.Info]: t("v8_set_info_status", "Set Info status"),
    [APPOINTMENT_NOTE_TYPES.BackOrder]: t("v8_back_order", "Back Order"),
    [APPOINTMENT_NOTE_TYPES.MakeAnOffer]: t("v8_set_make_offer_status", "Set Make an offer status"),
    [APPOINTMENT_NOTE_TYPES.Main]: isEdit ? t("v8_edit_main_note", "Edit Main Note") : t("v8_add_main_note", "Add Main Note"),
    [APPOINTMENT_NOTE_TYPES.CallCustomer]: isEdit ? t("v8_edit_call_customer_note", "Edit Call Customer Note") : t("v8_add_call_customer_note", "Add Call Customer Note"),
    [APPOINTMENT_NOTE_TYPES.Attachment]: isEdit ? t("v8_edit_attachment_note", "Edit Attachment Note") : t("v8_add_attachment_note", "Add Attachment Note"),
    [APPOINTMENT_NOTE_TYPES.Bill]: isEdit ? t("v8_edit_customer_bill", "Edit Customer Bill") : t("v8_add_customer_bill", "Add Customer Bill"),
    [APPOINTMENT_NOTE_TYPES.TempDriver]: isEdit ? t("v8_edit_temporary_driver", "Edit Temporary Driver") : t("v8_add_temporary_driver", "Add Temporary Driver"),
    [APPOINTMENT_NOTE_TYPES.RecurringCar]: isEdit ? t("v8_edit_recurring_car", "Edit recurring car") : t("v8_add_recurring_car", "Add Recurring Car"),
    [APPOINTMENT_NOTE_TYPES.ParkingLocation]: isEdit ? t("v8_edit_parking_location", "Edit parking location") : t("v8_add_parking_location", "Add parking location"),
    [APPOINTMENT_NOTE_TYPES.NoDrive]: t("v8_set_no_drive_status", "Set No Drive Status")
  };

  return (
    <div className="AppointmentNoteModalHeader">
      <NoteTypeIcon type={type} />
      <span>{noteLabels[type] ?? t("v8_add_note", "Add Note")}</span>
    </div>
  );
};
